module.exports = __webpack_public_path__ + "img/bg2.5471d4da.jpg";